export interface ApiGetTechAreaRequest {
    tech_desc: string;
    task_id: string;
}

export interface ApiGetTechAreaResponse {
    area: {
        feature: string;
        related_ipc: {
            code: string;
            desc: string;
        }[];
    },
    topics: {
        feature: string;
        desc: string;
        related_ipc: {
            code: string;
            desc: string;
        }[];
    }[];
}

export const GetTechArea = Symbol('GetTechArea');

export interface GetTechArea {
    getTechArea(data: ApiGetTechAreaRequest): Promise<ApiGetTechAreaResponse>;
}